<template>
  <div>
    <Dialog
      v-model="isVisible"
      :title="title"
      dialog-type="primary"
      dialog-size="large"
      :close-on-overlay="false"
      @close="initialize"
    >
      <template #header-icon>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
      </template>

      <div class="shortcut-dialog-body flex justify-between gap-2">
        <div class="w-full">
          <div class="select-tests-header">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
              <path d="M0 16.1914V4.82303C0 3.82414 0.790087 3.01439 1.76471 3.01439H2.54902C2.87389 3.01439 3.13725 3.28431 3.13725 3.61727C3.13725 3.95023 2.87389 4.22015 2.54902 4.22015H1.76471C1.43983 4.22015 1.17647 4.49007 1.17647 4.82303V16.1914C1.17647 16.5243 1.43983 16.7942 1.76471 16.7942H18.2353C18.5602 16.7942 18.8235 16.5243 18.8235 16.1914V4.82303C18.8235 4.49007 18.5602 4.22015 18.2353 4.22015H17.451C17.1261 4.22015 16.8627 3.95023 16.8627 3.61727C16.8627 3.28431 17.1261 3.01439 17.451 3.01439H18.2353C19.2099 3.01439 20 3.82415 20 4.82303V16.1914C20 17.1902 19.2099 18 18.2353 18H1.76471C0.790086 18 0 17.1902 0 16.1914Z" fill="#374957"/>
              <path d="M9.60784 0V1.36652H8.98039V10.9322C8.98039 11.657 8.71597 12.3522 8.24529 12.8648C7.77461 13.3773 7.13623 13.6652 6.47059 13.6652C5.80495 13.6652 5.16657 13.3773 4.69589 12.8648C4.22521 12.3522 3.96078 11.657 3.96078 10.9322V1.36652H3.33333V0H9.60784ZM7.72549 5.4661H5.21569V10.9322C5.21569 11.2946 5.3479 11.6422 5.58324 11.8985C5.81858 12.1547 6.13777 12.2987 6.47059 12.2987C6.80341 12.2987 7.1226 12.1547 7.35794 11.8985C7.59328 11.6422 7.72549 11.2946 7.72549 10.9322V5.4661ZM7.09804 8.88241C7.26445 8.88241 7.42404 8.95439 7.54171 9.08253C7.65938 9.21067 7.72549 9.38446 7.72549 9.56567C7.72549 9.74688 7.65938 9.92067 7.54171 10.0488C7.42404 10.1769 7.26445 10.2489 7.09804 10.2489C6.93163 10.2489 6.77203 10.1769 6.65436 10.0488C6.5367 9.92067 6.47059 9.74688 6.47059 9.56567C6.47059 9.38446 6.5367 9.21067 6.65436 9.08253C6.77203 8.95439 6.93163 8.88241 7.09804 8.88241ZM5.84314 6.83262C6.00955 6.83262 6.16914 6.90461 6.28681 7.03274C6.40448 7.16088 6.47059 7.33467 6.47059 7.51588C6.47059 7.6971 6.40448 7.87089 6.28681 7.99902C6.16914 8.12716 6.00955 8.19915 5.84314 8.19915C5.67673 8.19915 5.51713 8.12716 5.39946 7.99902C5.28179 7.87089 5.21569 7.6971 5.21569 7.51588C5.21569 7.33467 5.28179 7.16088 5.39946 7.03274C5.51713 6.90461 5.67673 6.83262 5.84314 6.83262ZM7.72549 1.36652H5.21569V4.09957H7.72549V1.36652Z" fill="#374957"/>
              <path d="M10.3922 0V1.36652H11.0196V10.9322C11.0196 11.657 11.284 12.3522 11.7547 12.8648C12.2254 13.3773 12.8638 13.6652 13.5294 13.6652C14.1951 13.6652 14.8334 13.3773 15.3041 12.8648C15.7748 12.3522 16.0392 11.657 16.0392 10.9322V1.36652H16.6667V0H10.3922ZM12.902 9.56567C12.5255 9.56567 12.2745 9.29237 12.2745 8.88241C12.2745 8.47245 12.5255 8.19915 12.902 8.19915C13.2784 8.19915 13.5294 8.47245 13.5294 8.88241C13.5294 9.29237 13.2784 9.56567 12.902 9.56567ZM14.1569 6.83262C13.7804 6.83262 13.5294 6.55932 13.5294 6.14936C13.5294 5.7394 13.7804 5.4661 14.1569 5.4661C14.5333 5.4661 14.7843 5.7394 14.7843 6.14936C14.7843 6.55932 14.5333 6.83262 14.1569 6.83262ZM14.7843 3.41631H12.2745V1.36652H14.7843V3.41631Z" fill="#374957"/>
            </svg>
            Select Tests
          </div>
          <div class="home-collection-toggle-wrapper">
            <div class="home-collection-label-wrapper">
              <span class="home-collection-toggle-text">Show Home Collection tests only?</span>
              <Tooltip position="down" :multi_line="true">
                <span class="material-icons-outlined info-icon">info</span>
                <template #content>
                  You can view tests that can be self-collected by patients and will be shipped to patient's home. This is more convenient, and you can order specials with Savings!
                </template>
              </Tooltip>
            </div>
            <div class="status-toggle">
              <span class="status-label inactive-label">Off</span>
              <div class="toggle-switch" :class="{ 'active': isDbsVersion }" @click="toggleHomeCollection">
                <div class="toggle-track">
                  <div class="toggle-thumb"></div>
                </div>
              </div>
              <span class="status-label active-label">On</span>
            </div>
          </div>
          <OrderTestPanel
            ref="orderTestPanelRef"
            :key="orderTestPanelKey"
            class="mt-2"
            selectProp="isSelectForShortcut"
            :orderTestSupportObj="orderTestSupportObj"
            isNotAllowedSelectProp="isNotAllowedSelectForShortcut"
            :is-show-merch-tab-parent="false"
            :display-item-data="displayItemData"
            :custom-panel-list="customPanelList"
          />
        </div>
        <div class="flex flex-col name-shortcut-container">
          <div>
            <div class="customize-bundle-header">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M13 0C10.29 0 7.95 1.54 6.78 3.78C5.5 4.45 4.44 5.5 3.78 6.78C1.54 7.95 0 10.29 0 13C0 16.87 3.13 20 7 20C9.71 20 12.05 18.46 13.22 16.22C14.5 15.55 15.56 14.5 16.22 13.22C18.46 12.05 20 9.71 20 7C20 3.13 16.87 0 13 0ZM7 18C4.24 18 2 15.76 2 13C2 11.88 2.37 10.84 3 10C3 13.87 6.13 17 10 17C9.16 17.63 8.12 18 7 18ZM10 15C7.24 15 5 12.76 5 10C5 8.88 5.37 7.84 6 7C6 10.86 9.13 13.99 13 14C12.16 14.63 11.12 15 10 15ZM14.7 11.7C14.17 11.89 13.6 12 13 12C10.24 12 8 9.76 8 7C8 6.4 8.11 5.83 8.3 5.3C8.83 5.11 9.4 5 10 5C12.76 5 15 7.24 15 10C15 10.6 14.89 11.17 14.7 11.7ZM17 10C17 6.14 13.87 3.01 10 3C10.84 2.37 11.87 2 13 2C15.76 2 18 4.24 18 7C18 8.12 17.63 9.16 17 10Z" fill="#374957"/>
              </svg>
              <span>Customize Bundle Properties</span>
            </div>
            <label class="field-label">
              Name your bundle <span class="required">(Required)</span>
            </label>
            <el-form ref="shortcutNameForm" class="shortcut-name-input mt-3" :model="shortcutNameForm" :rules="shortcutNameRules" :show-error="false">
              <el-form-item prop="name" :show-error="false">
                <TextInput
                  v-model="shortcutNameForm.name"
                  size="medium"
                  :clearable="false"
                  placeholder="Type your shortcut name"
                />
              </el-form-item>
            </el-form>

            <!-- Price Update By Percentage -->
            <div class="mt-2">
              <label class="field-label">
                Bundle Price
              </label>
              <TextInput
                v-model="pricePercentage"
                size="medium"
                placeholder="10"
                :clearable="true"
              >
                <template #prefix>
                  <span class="bundle-price-prefix">+</span>
                </template>
                <template #suffix>
                  <span class="bundle-price-suffix">%</span>
                </template>
              </TextInput>
              <InlineNotification
                v-if="showPriceError"
                class="my-2"
                theme="error"
                message="The retail price must not exceed 150% of wholesale price."
                :with_close_btn="false"
              />
              <div class="bundle-price-summary">
                <span class="price-summary-label">Current Price:</span>
                <span class="price-summary-value">${{ currentBasePrice.toFixed(2) }}</span>
              </div>
              <div class="bundle-price-summary updated-price">
                <span class="price-summary-label">Bundle Price:</span>
                <span class="price-summary-value">${{ adjustedBundlePrice.toFixed(2) }}</span>
              </div>
            </div>

            <ShortcutDialogSelectedTests 
              class="mt-7" 
              :itemList="selectedItemList" 
              :selectedVwTestPrice="selectedVwTestPrice"
              :processing-and-cap-off-value="processingAndCapOffValue"
              :shortcut-price="shortcutPrice"
              :non-return-patient-processing-fee-calcd="nonReturnPatientProcessingFeeCalcd"
              :return-patient-processing-fee-calcd="returnPatientProcessingFeeCalcd"
              :non-return-patient-estimated-total="nonReturnPatientEstimatedTotal"
              :return-patient-estimated-total="returnPatientEstimatedTotal"              
              @removeItem="handleRemoveTest"
            />
          </div>
          <div class="my-5">
            <InlineNotification
              v-if="hasUnavailableItems"
              class="mb-2"
              theme="warning"
              message="Remove the unavailable markers or tests to save and reactivate your bundle."
              action_text="Click to remove"
              :with_close_btn="false"
              @action="removeUnavailableTests"
            />
            <div v-if="selectedShortcut && !hideDeleteButton" class="delete-bundle-wrapper mb-4">
              <button class="delete-bundle-btn" @click="isOpenDeleteShortcutModal = true">
                <img src="@/assets/orderTest/order-page/favorites/delete_forver_icon_18px.svg" class="mr-3">
                {{ $t("OrderPage[\"Delete Bundle\"]") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Buttons -->
      <template #footer>
        <ResponsiveButton
          button_type="outlined"
          built_in_theme="error"
          size="medium"
          :display_name="$t('OrderPage[\'Cancel\']')"
          @click-button="initialize"
        />
        <ResponsiveButton
          button_type="filled"
          built_in_theme="dark"
          size="medium"
          :display_name="selectedShortcut ? $t('OrderPage[\'Save Bundle\']') : $t('OrderPage[\'Create Bundle\']')"
          :disabled="hasUnavailableItems || !shortcutNameForm.name || showPriceError"
          @click-button="createOrUpdateBundle('shortcutNameForm')"
        />
      </template>
    </Dialog>
    <MultipleXChooseYSelectionDialog
      :isShowDialog="isOpenMultipleXChooseYSelectionDialog"
      itemCategory="custom panel"
      :title="currentSelectedPanel.bundleName" 
      :xChooseYPanelList="xChooseYPanelList"
      selectProp="isSelectForShortcut"
      @done="handleDone"
      @close="isOpenMultipleXChooseYSelectionDialog = false"
    />
    <DeleteShortcutModal
      v-if="selectedShortcut" 
      :is-show-dialog="isOpenDeleteShortcutModal"
      :shortcut-name="shortcutNameForm.name"
      @close="isOpenDeleteShortcutModal = false"
      @delete="removeShortcut(selectedShortcut)"
    />
  </div>
</template>

<script>
import OrderTestPanel from "../../../order-test-panel/index.vue";
import ShortcutDialogSelectedTests from "./ShortcutDialogSelectedTests.vue";
import MultipleXChooseYSelectionDialog from "../../../MultipleXChooseYSelectionDialog.vue";
import DeleteShortcutModal from "./DeleteShortcutModal.vue";
import _ from "lodash";
import { mapGetters, mapState, mapActions } from "vuex";
import { createShortcutApi, updateShortcutApi, deleteShortcutApi } from "@/api/va-order-page/pricing/item/catalog.js";
import { postMarkUps, getMarkUps } from '@/api/markup';
import { getBodyForSaveAndUpdateShortcutBackendApi, getShortcutForFrontend } from "./shortcutDialog.js";
import { addSelectedTest, removeSelectedTest } from "@/utils/va-order-test/testAndPanelSelection/testSelection.js";
import { addSelectedDiscountPanel, removeSelectedDiscountPanel } from "@/utils/va-order-test/testAndPanelSelection/discountPanelSelection.js";
import { addSelectedXChooseYPanel, removeSelectedXChooseYPanel } from '@/utils/va-order-test/testAndPanelSelection/xChooseYPanelSelection.js';
import { addSelectedCustomPanel, removeSelectedCustomPanel } from "@/utils/va-order-test/testAndPanelSelection/customPanelSelection.js";
import { handleException, handleBloodSalivaAddonException } from "@/utils/va-order-test/testAndPanelSelection/handleException.js";
import { handleDuplicateTests } from "@/utils/va-order-test/testAndPanelSelection/handleDuplicateTests.js";
import { clearAllSelectedItems, handleBestDealSuggestion } from "@/utils/va-order-test/bestDealSuggestion";
import { getVwTestsPrice, applyConditionalDiscounts } from "@/utils/va-order-test/index.js";
import { notify } from "@/utils/notify";
import { removeSelectedSeasonalPromo } from "@/utils/va-order-test/testAndPanelSelection/seasonalPromoSelection";
import { cloneOrderTestTreeAndBundles } from "@/store/modules/va-order-test/helpers/deepCopyHelpers";
import { getNutriprozIdToRemove } from "@/store/modules/va-order-test/helpers/tests";
import { iconProps } from "element-plus";

export default {
  components: {
    OrderTestPanel,
    ShortcutDialogSelectedTests,
    MultipleXChooseYSelectionDialog,
    DeleteShortcutModal,
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false
    },
    selectedShortcut: {
      type: Object,
      default: () => {}
    },
    hideDeleteButton: {
      type: Boolean,
      default: false
    },
    // Provider's customer_id for markup saving (used by ProductBundles)
    selectedProvider: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    // Clone order test tree data and bundles from store
    // Returns an object containing:
    // - bundleList, vaRootNodeList, vwRootNodeList, vwCategories, regenereIdList, nutriprozIdList (deep copied root-level data)
    // - vaBfsList, vwBfsList, bfsTestList, testList, vwTestList (derived lists as arrays)
    // - serumCategorizedVwTests, dbsCategorizedVwTests (categorized VW tests - both versions)
    // - regenereNodeList, nutriprozNodeList (derived node lists)
    // - discountPanelList, serumDiscountPanelList, dbsDiscountPanelList (derived discount panel lists)
    const deepCopies = cloneOrderTestTreeAndBundles();
    
    return {
      isVisible: false,
      isOpenMultipleXChooseYSelectionDialog: false,
      isOpenDeleteShortcutModal: false,
      shortcutNameForm: { name: "" },
      // Price update by percentage
      pricePercentage: '',
      selectedTestIdList: [],
      selectedDiscountPanelIdList: [],
      selectedXChooseYPanelIdList: [],
      selectedCustomPanelIdList: [],
      selectedSeasonalPromoList: [],
      currentSelectedPanel: {},
      xChooseYPanelList: [],
      displayItemData: deepCopies,
      ...deepCopies,
      orderTestPanelKey: 0
    }
  },
  computed: {
    // Properties that can't be derived and aren't in orderTestSupportObj - keep from store
    ...mapState("orderTest", [
      "discountMap",
      "isDbsVersion",
      "bestDealSupportMapping",
      "processingAndCapOffValue",
      "dbsMap",
    ]),
    ...mapState("orderTest/exceptions", ["exceptionMap"]),
    ...mapState("orderTest/favorites", ["selectedShortcutIdList"]),
    ...mapState("orderTest/user", ["userInfo"]),
    ...mapGetters("orderTest/tests", ["nonOrderableTestIds"]),
    ...mapGetters("orderTest/panels", ["nonOrderableDiscountPanelIds"]),

    // Derive properties from orderTestSupportObj
    shortcutList() {
      return this.orderTestSupportObj?.shortcutList || [];
    },
    seasonalPromotionList() {
      return this.orderTestSupportObj?.seasonalPromotionList || [];
    },

    customPanelList() {
      const list = this.bundleList.filter(panel => panel.category === "customPanel");
      return list;
    },

    title() {
      return this.selectedShortcut 
        ? this.$t("OrderPage[\"Edit Shortcut Bundles\"]") : this.$t("OrderPage[\"Create New Shortcut Bundles\"]");
    },

    shortcutNameRules() {
      return {
        name: [
          {
            required: true,
            trigger: 'blur'
          }
        ]
      };
    },

    selectedItemList() {
      return this.selectedTestList
        .concat(this.selectedDiscountPanelList)
        .concat(this.selectedCustomPanelList)
        .concat(this.selectedXChooseYPanelList)
        .concat(this.selectedSeasonalPromoList);
    },

    selectedTestList() {
      return this.testList.filter(t => this.selectedTestIdList.includes(t.id));
    },

    selectedDiscountPanelList() {
      return this.bundleList
        .filter(b => b.category === "discountPanel")
        .filter(b => this.selectedDiscountPanelIdList.includes(b.bundleId));
    },

    selectedXChooseYPanelList() {
      return this.bundleList  
        .filter(b => b.category === "xChooseY")
        .filter(b => this.selectedXChooseYPanelIdList.includes(b.bundleId));
    },

    selectedCustomPanelList() {
      return this.customPanelList
        .filter(b => this.selectedCustomPanelIdList.includes(b.bundleId));
    },
    shortcutPrice() {
      let price = 0;
      this.selectedItemList.forEach(test => {
        price += test.price;
      });
      return price;
    },

    selectedItemsObj() {
      return {
        selectedTestList: this.selectedTestList,
        selectedDiscountPanelList: this.selectedDiscountPanelList,
        selectedCustomPanelList: this.selectedCustomPanelList,
        selectedXChooseYPanelList: this.selectedXChooseYPanelList,
        selectedSeasonalPromoList: this.selectedSeasonalPromoList
      }
    },

    // price for ordered vw tests - include bundle containing vw tests
    selectedVwTestPrice(){
      return getVwTestsPrice(this.selectedItemList, this.vwTestList);
    },

    // shortcut price that not consider xChooseY panels with no zoomer selected
    shortcutPriceWithNoEmptyXChooseYPanels() {
      let emptyXChooseYs = this.selectedItemList.filter(item => {
        return item.category === "xChooseY" && item.selectedZoomerIdList.length === 0
      });
      let emptyXChooseYsPrice = emptyXChooseYs
        .reduce((acc, xChooseY) => acc + xChooseY.price, 0);
      return this.shortcutPrice - emptyXChooseYsPrice;
    },

    orderTestSupportObj() {
      return {
        testNodeList: this.bfsTestList,
        bundleList: this.bundleList,
        seasonalPromotionList: this.seasonalPromotionList,
        shortcutList: this.shortcutList,
        exceptionMap: this.exceptionMap,
        dbsMap: this.dbsMap,
        selectedTestIdList: this.selectedTestIdList,
        selectedDiscountPanelIdList: this.selectedDiscountPanelIdList,
        selectedXChooseYPanelIdList: this.selectedXChooseYPanelIdList,
        selectedCustomPanelIdList: this.selectedCustomPanelIdList,
        selectedSeasonalPromoList: this.selectedSeasonalPromoList,
        selectedShortcutIdList: [],
        selectedItemList: this.selectedItemList,
        selectedVwTestPrice: this.selectedVwTestPrice,
        isFavPanelOpen: true,
        editOrderItemList: [],
        bestDealSupportMapping: this.bestDealSupportMapping,
      }
    },

    nonReturnPatientProcessingFeeCalcd() {
      return this.shortcutPrice > this.processingAndCapOffValue.nonReturningCustomerCapFee 
        ? 0 
        : this.processingAndCapOffValue.nonReturningLabProcessingFee + this.shortcutPrice > 
          this.processingAndCapOffValue.nonReturningCustomerCapFee 
        ? this.processingAndCapOffValue.nonReturningCustomerCapFee - this.shortcutPrice
        : this.processingAndCapOffValue.nonReturningLabProcessingFee;
    },

    returnPatientProcessingFeeCalcd() {
      return this.shortcutPrice > this.processingAndCapOffValue.returningCustomerCapFee 
        ? 0 
        : this.processingAndCapOffValue.returningLabProcessingFee + this.shortcutPrice > 
          this.processingAndCapOffValue.returningCustomerCapFee 
        ? this.processingAndCapOffValue.returningCustomerCapFee - this.shortcutPrice
        : this.processingAndCapOffValue.returningLabProcessingFee;
    },

    nonReturnPatientEstimatedTotal() {
      return this.nonReturnPatientProcessingFeeCalcd + this.shortcutPrice;
    },

    returnPatientEstimatedTotal() {
      return this.returnPatientProcessingFeeCalcd + this.shortcutPrice;
    },

    // Current base price (without percentage adjustment)
    currentBasePrice() {
      return this.shortcutPrice;
    },

    // Adjusted bundle price with percentage
    adjustedBundlePrice() {
      const percentage = parseFloat(this.pricePercentage) || 0;
      return this.shortcutPrice * (1 + percentage / 100);
    },

    // Show price error when percentage is set and exceeds 50%
    showPriceError() {
      const value = this.pricePercentage?.trim();
      if (!value) return false;
      const numValue = parseFloat(value);
      return !isNaN(numValue) && numValue > 50;
    },

    isAnyThreeDBSPromoStart() {
      if(this.seasonalPromotionList.find(x => x.discountName === "5 for $1000 Bundle")) {
        return true
      }
      return false
    },
    hasUnavailableItems() {
      let { nonMicronutrient } = this.nonOrderableTestIds;
      let xChooseYTestIds = this.selectedXChooseYPanelList
        .map(panel => {
          let { selectedZoomerIdList, selectedSupplementIdList } = panel;
          return (selectedZoomerIdList || []).concat(selectedSupplementIdList || [])
        }).flat();
      return this.selectedTestIdList.concat(xChooseYTestIds).some(id => nonMicronutrient.includes(id)) 
        || this.selectedDiscountPanelList.some(id => this.nonOrderableDiscountPanelIds.includes(id))
        ? true : false;
    }
  },
  watch: {
    pricePercentage(newVal) {
      // Sanitize: only digits and decimal point (replaces old @input handler)
      if (typeof newVal !== 'string') return;
      const cleaned = newVal.replace(/[^\d.]/g, '');
      if (cleaned !== newVal) {
        this.pricePercentage = cleaned;
      }
    },
    async isShowDialog(newVal) {
      this.isVisible = newVal;
      if (newVal === true) {
        // Fetch processing fee and cap-off values
        this.setProcessingFeeAndCapOffValue();
        // Ensure bestDealSupportMapping and discountMap are loaded for bundle replacement
        await Promise.all([
          this.$store.dispatch("orderTest/setBestDealMapping"),
          this.$store.dispatch("orderTest/fetchDiscountMap")
        ]);
        // Re-initialize deep copies when dialog opens to get latest data
        // Use nextTick to avoid Vue reactivity issues with circular references
        this.$nextTick(async () => {
          const deepCopies = cloneOrderTestTreeAndBundles();
          this.displayItemData = deepCopies;
          Object.assign(this, {
            ...deepCopies,
          });
          this.orderTestPanelKey++; // force re-render the order test panel to ensure the tree structure rendered correctly
          if (this.selectedShortcut) {
            this.initializeSelectedItemList();
            this.shortcutNameForm.name = this.selectedShortcut.shortcutName;
            // Use markup percentage from selectedShortcut if available (passed from ProductBundles)
            // Otherwise fetch from API
            if (this.selectedShortcut.markupPercentage) {
              this.pricePercentage = this.selectedShortcut.markupPercentage;
            } else {
              await this.fetchExistingMarkup(this.selectedShortcut.id);
            }
          }
        });
      }
    },

    // find best deal panel and test combination (exclude for custom panel)
    selectedItemList(newValue, oldValue) {
      // console.log("oldValue", oldValue.map(item => item.id));
      // console.log("newValue", newValue.map(item => item.id));
      // disable bundle suggestion if in fav test dialog
      let isSame = newValue.length === oldValue.length 
        && newValue.every(newV => oldValue.find(oldV => oldV.id ? oldV.id === newV.id : oldV.bundleId === newV.bundleId));
      if (isSame) {
        return;
      }

      // Apply conditional discounts
      applyConditionalDiscounts(this.testList, "isSelectForShortcut", newValue);

      // handle exceptions  
      handleException("isSelectForShortcut", "isNotAllowedSelectForShortcut", this.orderTestSupportObj);
      // handle special rule for blood/saliva addons
      handleBloodSalivaAddonException("isSelectForShortcut", "isNotAllowedSelectForShortcut", this.orderTestSupportObj);
      // console.log("after exception", [...this.selectedTestIdList])
      handleDuplicateTests("isSelectForShortcut", this.orderTestSupportObj);
      // console.log("after duplicate tests", [...this.selectedTestIdList])
      if (newValue.length === 0) {
        return;
      }
      // this.$emit("handleIsSuggestionLoading", true);
      let isBundleReplaceTriggered = handleBestDealSuggestion("isSelectForShortcut", this.shortcutPriceWithNoEmptyXChooseYPanels, this.orderTestSupportObj, this.discountMap, this.isDbsVersion);
      if (isBundleReplaceTriggered) {
        this.$store.dispatch("orderTest/setBundleReplaceTriggered");
      }
      // console.log("after deal suggestion", [...this.selectedTestIdList])
    }
  },

  methods: {
    ...mapActions("orderTest", ["setProcessingFeeAndCapOffValue"]),
    async fetchExistingMarkup(shortcutId) {
      try {
        const userInfo = this.userInfo;
        if (!userInfo || (!userInfo.customer_id && !userInfo.clinic_id)) {
          return;
        }

        const isClinic = userInfo.isClinic;
        const accountId = isClinic ? userInfo.clinic_id : userInfo.customer_id;
        // Use selectedProvider prop, or shortcut's customer_id, or userInfo.customer_id
        const shortcutCustomerId = this.selectedProvider || this.selectedShortcut?.customer_id || userInfo.customer_id;
        const affiliateIds = [shortcutCustomerId];

        const { data } = await getMarkUps({
          account_type: isClinic ? 'clinic' : 'customer',
          account_id: Number(accountId),
          affiliate_ids: affiliateIds,
          customer_id: Number(userInfo.customer_id),
          clinic_id: Number(userInfo.clinic_id)
        });

        const markupSchemes = data?.markup_schemes || {};
        const accountSchemes = markupSchemes[shortcutCustomerId] || [];

        // Find markup scheme for this shortcut
        const markupScheme = accountSchemes.find(s =>
          s.item_type === 'shortcutId' && String(s.item_id) === String(shortcutId)
        );

        if (markupScheme && markupScheme.markup_type === 'added_percentage') {
          // Convert decimal to percentage (e.g., 0.1 -> 10)
          const percentageValue = (markupScheme.markup_value * 100).toFixed(0);
          this.pricePercentage = percentageValue;
        }
      } catch (error) {
        console.error('[ShortcutDialog] Error fetching existing markup:', error);
      }
    },
    createOrUpdateBundle(formName) {
      // check whether shortcut name is given
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return;
        }
        if (this.selectedItemList.length === 0) {
          // check whether tests are selected
          notify({
            type: 'error',
            message: this.$t("OrderPage[\"Please select tests.\"]")
          });
          return;
        }
        let loading = this.$loading({
          target: '.general-dialog:has(.shortcut-dialog-body)',
          text: this.selectedShortcut ? this.$t("OrderPage[\"Updating...\"]") : this.$t("OrderPage[\"Creating...\"]"),
          spinner: 'el-icon-loading',
        });

        let shortcutName = this.shortcutNameForm.name;
        let shortcutBody = getBodyForSaveAndUpdateShortcutBackendApi(
          shortcutName, 
          this.isDbsVersion,
          this.selectedItemsObj, 
          this.vaBfsList
        );
        try {
          let res = this.selectedShortcut
            ? await updateShortcutApi({ id: this.selectedShortcut.id, ...shortcutBody})
            : await createShortcutApi(shortcutBody);

          // Update markup if percentage is set
          if (this.pricePercentage && this.pricePercentage.trim()) {
            try {
              const shortcutId = this.selectedShortcut ? this.selectedShortcut.id : res.data.shortcut_id;
              const markupValue = parseFloat(this.pricePercentage) / 100; // Convert % to decimal

              // markup_schemes key should be the provider's customer_id (affiliate_id)
              // For clinic: use selectedProvider prop, or shortcut's customer_id, or userInfo.customer_id
              // For customer: use customer_id
              const affiliateId = this.selectedProvider || this.selectedShortcut?.customer_id || this.userInfo.customer_id;
              const payload = {
                account_type: this.userInfo.isClinic ? 'clinic' : 'customer',
                account_id: this.userInfo.isClinic ? this.userInfo.clinic_id : this.userInfo.customer_id,
                clinic_id: this.userInfo.clinic_id,
                customer_id: this.userInfo.customer_id,
                markup_schemes: {
                  [affiliateId]: [{
                    item_type: 'shortcutId',
                    item_id: String(shortcutId),
                    item_name: shortcutName,
                    markup_type: 'added_percentage',
                    markup_value: markupValue,
                    changeable: true,
                    customized_name: shortcutName
                  }]
                }
              };

              await postMarkUps(payload);
            } catch (markupErr) {
              console.error('Failed to update markup:', markupErr);
            }
          }

          if (this.selectedShortcut) {
            console.log("successfully update shortcut", this.selectedShortcut.id);
            let newShortcut = getShortcutForFrontend(
              shortcutName,
              this.shortcutPrice,
              this.selectedShortcut.id,
              this.selectedShortcut.isSelect,
              this.isDbsVersion,
              this.selectedItemsObj
            );
            this.$store.dispatch("orderTest/favorites/setShortcutSampleTypes", newShortcut);
            this.$store.dispatch("orderTest/favorites/updateFavoriteShortcut", {
              originalShortcut: this.selectedShortcut,
              newShortcut
            });
          }
          else {
            let newShortcut = getShortcutForFrontend(
              shortcutName,
              this.shortcutPrice,
              res.data.shortcut_id,
              false,
              this.isDbsVersion,
              this.selectedItemsObj
            );
            this.$store.dispatch("orderTest/favorites/setShortcutSampleTypes", newShortcut);
            // save to store
            this.$store.dispatch("orderTest/favorites/addFavoriteShortcut", newShortcut);
          }
          let message = this.selectedShortcut
            ? this.$t("OrderPage[\"Successfully update shortcut.\"]")
            : this.$t("OrderPage[\"Successfully create shortcut.\"]");
          notify({
            type: 'success',
            message
          })
          loading.close();
          this.initialize();
        }
        catch (err) {
          loading.close();
        }
      });
    },

    initialize() {
      this.$emit("close");
      clearAllSelectedItems("isSelectForShortcut", this.orderTestSupportObj);
      this.shortcutNameForm.name = "";
      this.pricePercentage = "";
      // Reset home collection toggle to OFF when dialog closes
      if (this.isDbsVersion) {
        this.$store.dispatch("orderTest/setIsDbsVersion", false);
      }
    },

    toggleHomeCollection() {
      const nextDbsToggle = !this.isDbsVersion;
      const orderPanelRef = this.$refs.orderTestPanelRef;
      if (orderPanelRef?.changeDbsVersion) {
        orderPanelRef.changeDbsVersion(nextDbsToggle);
      }
    },


    handleRemoveTest(item) {
      item.category === "discountPanel"
        ? removeSelectedDiscountPanel(item.bundleId, "isSelectForShortcut", this.orderTestSupportObj)
        : item.category === "customPanel"
        ? removeSelectedCustomPanel(item.bundleId, "isSelectForShortcut", this.orderTestSupportObj)
        : item.category === "xChooseY"
        ? removeSelectedXChooseYPanel(item.bundleId, "isSelectForShortcut", this.orderTestSupportObj)
        : item.category === "seasonalPromo"
        ? removeSelectedSeasonalPromo(item, "isSelectForShortcut", this.orderTestSupportObj)
        : removeSelectedTest(item.id, "isSelectForShortcut", this.orderTestSupportObj);
    },

    initializeSelectedItemList() {
      let { testIdList, discountPanelIdList, customPanelIdList, xChooseYIdList } = this.selectedShortcut;
      testIdList.forEach(id => {
        addSelectedTest(id, "isSelectForShortcut", this.orderTestSupportObj);
      });
      discountPanelIdList.forEach(id => {
        addSelectedDiscountPanel(id, "isSelectForShortcut", this.orderTestSupportObj);
      });
      customPanelIdList.forEach(id => {
        addSelectedCustomPanel(id, "isSelectForShortcut", this.orderTestSupportObj);
      });
      xChooseYIdList.filter(panel => !panel.customPanelId).forEach(panel => {
        let foundPanel = this.bundleList.find(p => p.bundleId === panel.bundleId);
        if (foundPanel) {
          foundPanel.selectedZoomerIdList = panel.selectedZoomerIdList;
          foundPanel.zoomerList = panel.zoomerList;
          foundPanel.selectedSupplementIdList = panel.selectedSupplementIdList;
          addSelectedXChooseYPanel(panel.bundleId, "isSelectForShortcut", this.orderTestSupportObj);
        } else {
          console.warn('[ShortcutDialog] xChooseY panel not found in bundleList:', panel.bundleId);
        }
      });
    },

    handleDone(finishedXChooseYs) {
      this.currentSelectedPanel.isSelectForShortcut = true;
      this.currentSelectedPanel.selectedXChooseYPanelList = finishedXChooseYs;
      addSelectedCustomPanel(this.currentSelectedPanel.bundleId, "isSelectForShortcut", this.orderTestSupportObj);
      this.isOpenMultipleXChooseYSelectionDialog = false;
    },

    // remove a shortcut inside the edit dialog
    async removeShortcut(item) {
      let loading = this.$loading({
        target: '.general-dialog:has(.shortcut-dialog-body)',
        text: this.$t("OrderPage[\"Deleting...\"]"),
        spinner: 'el-icon-loading',
      });
      try {
        await deleteShortcutApi({ shortcut_id: item.id });
        this.isOpenDeleteShortcutModal = false;
        // remove the shortcut from selected shortcut list if any
        if (this.selectedShortcutIdList.includes(item.id)) {
          this.$store.dispatch("orderTest/removeSelectedShortcut", item);
        }
        this.$store.dispatch("orderTest/favorites/removeFavoriteShortcut", item);
        notify({
          type: 'success',
          message: this.$t("OrderPage[\"Successfully delete shortcut\"]")
        })
        loading.close();
        this.initialize();
      } catch (err) {
        loading.close();
      }
    },

    removeUnavailableTests() {
      let { nonMicronutrient } = this.nonOrderableTestIds;
      let unavailableTestIds = this.selectedShortcut.testIdList.filter(id => nonMicronutrient.includes(id));
      let unavailableXChooseYPanelTestIds = this.selectedShortcut.xChooseYIdList.map(panel => {
        let { selectedZoomerIdList, selectedSupplementIdList } = panel;
        return (selectedZoomerIdList || []).concat(selectedSupplementIdList || [])
      }).flat().filter(id => nonMicronutrient.includes(id));
      unavailableTestIds.concat(unavailableXChooseYPanelTestIds).forEach(id => removeSelectedTest(id, "isSelectForShortcut", this.orderTestSupportObj));
      let unavailableDiscountPanelIds = this.selectedShortcut.discountPanelIdList.filter(id => this.nonOrderableDiscountPanelIds.includes(id));
      unavailableDiscountPanelIds.forEach(id => removeSelectedDiscountPanel(id, "isSelectForShortcut", this.orderTestSupportObj));
    }
  }
}
</script>

<style scoped>
.shortcut-dialog-body {
  padding: 12px 0;
}

.name-shortcut-container {
  border-radius: 10px;
  background: var(--Neutral-White, #FFF);

  /* EHR_RegularShadow */
  box-shadow: 0 1px 15px 0 rgba(164, 164, 164, 0.25);
  display: flex;
  width: 294px;
  padding: 8px 8px 0 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex-shrink: 0;
  align-self: stretch;
}

.customize-bundle-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.customize-bundle-header svg {
  width: 24px;
  height: 24px;
}

.customize-bundle-header span {
  color: var(--TrueBlack, #333);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
}

.name-shortcut-title {
  height: 16px;
  font-size: 14px;
  letter-spacing: 0.4px;
}

.field-label {
  display: block;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #4A4A4A;
  margin-bottom: 6px;
}

.required {
  color: #D10000;
  font-weight: 500;
}

/* Name input styling to match Edit Retail Details style */
.shortcut-name-input :deep(.el-input__inner) {
  border-radius: 4px;
  border: 1px solid #D9D9D9;
  padding: 8px 12px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: #333;
  background: #FFFFFF;
  transition: all 0.2s;
}

.shortcut-name-input :deep(.el-input__inner):hover {
  border-color: #409EFF;
}

.shortcut-name-input :deep(.el-input__inner:focus) {
  border-color: #409EFF;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

.delete-bundle-wrapper {
  width: 100%;
}

.delete-bundle-btn {
  height: 36px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 4px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.429px;
  color: #FF1D00;
  border: 1px solid #FF1D00;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.delete-bundle-btn:hover {
  background: #FFF5F5;
}

.click-remove {
 color: #20A7C1;
}

.select-tests-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--TrueBlack, #333);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px; /* 150% */
  letter-spacing: 0.15px;
}

.home-collection-toggle-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  margin-bottom: 8px;
}

.home-collection-label-wrapper {
  display: flex;
  align-items: center;
}

.home-collection-toggle-text {
  overflow: hidden;
  color: var(--color-Grey-Grey-4A, #4A4A4A);
  text-overflow: ellipsis;

  /* EHR_TitleS_14_WM */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.1px;
}

/* Status Toggle - matching PracticeProductCard style */
.status-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(249, 251, 253, 0.90);
  border-radius: 8px;
  padding: 3px 6px;
  height: 28px;
}

.status-label {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.inactive-label {
  color: var(--TrueBlack, #333);
}

.active-label {
  color: var(--TrueBlack, #333);
}

.toggle-switch {
  width: 40px;
  height: 22px;
  cursor: pointer;
}

.toggle-track {
  width: 100%;
  height: 100%;
  border-radius: 11px;
  background: #E3E5E8;
  position: relative;
  transition: background 0.2s;
}

.toggle-switch.active .toggle-track {
  background: var(--IconGrey, #374957);
}

.toggle-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #FFF;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: left 0.2s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
}

.toggle-switch.active .toggle-thumb {
  left: 20px;
  background: linear-gradient(90deg, #E6EDF2 0%, #EAF8F9 100%);
}

.info-icon {
  margin-left: 4px;
  font-size: 18px;
  cursor: pointer;
  color: #979797;
  vertical-align: text-bottom;
}

/* Bundle Price (TextInput prefix/suffix slots) */
.bundle-price-prefix,
.bundle-price-suffix {
  color: var(--IconGrey, #374957);
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.bundle-price-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  padding: 8px 0;
}

.price-summary-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #4A4A4A;
}

.price-summary-value {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.bundle-price-summary.updated-price {
  border-top: 1px solid #E3E5E8;
  margin-top: 12px;
  padding-top: 12px;
}

.bundle-price-summary.updated-price .price-summary-label {
  color: #004879;
}

.bundle-price-summary.updated-price .price-summary-value {
  color: #004879;
  font-size: 16px;
}
</style>

<style>
/* Dialog teleports its DOM to <body>, so scoped :deep() can't reach it.
   Match the dialog that wraps our .shortcut-dialog-body. */

/* Hide form error messages (validation is gated by submit handler, not inline) */
.general-dialog:has(.shortcut-dialog-body) .el-form-item__error {
  display: none !important;
}

/* Search Test input inside the dialog */
.general-dialog:has(.shortcut-dialog-body) .search-test-selector .el-select__wrapper {
  height: 42px !important;
  min-height: 42px !important;
}

/* OrderTestPanel width cap inside the dialog */
.general-dialog:has(.shortcut-dialog-body) .w-full {
  max-width: 740px;
}
</style>
